import { useState } from "react";
import ReactPlayer from "react-player/file"

export const VideoPlayer = ({playerRef, videoAvailable, setVideoAvailable, vconfig, url}) => {
  const [playing, setPlaying] = useState(false)
  return (
    <div className="media">
      <div className="media_videoframe" style={videoAvailable ? {} : { display: 'none' }}>
        <ReactPlayer ref={playerRef} url={url} config={vconfig} controls onError={(e, ele) => { setVideoAvailable(false); console.log(e) }} playing={playing} onReady={(e)=>{setPlaying(true)}} /> {/*mute playing onReady={handleOnReady}*/}
      </div>
      <div className="media_videoframe media_not_available" style={videoAvailable ? { display: 'none' } : {}}><span>未選擇影片/影片播放錯誤/影片不存在</span></div>
      <div className="clear" />
    </div>
  )
}